import apiClient from "./apiClient";
import {
  DEFAULT_EXPIRY_THRESHOLD_MONTHS,
  notifyPathExpiryThresholdChanged,
  parseExpiryThresholdMonths,
  readPathExpiryThresholdMonthsFromStorage,
  writePathExpiryThresholdMonthsToStorage,
} from "../utils/pathExpiryThreshold";

const SETTINGS_BASE = "/path-settings";

export const getPathExpiryThresholdMonths = async (organizationId) => {
  try {
    const response = await apiClient.get(`${SETTINGS_BASE}/expiry-threshold`);
    const months = parseExpiryThresholdMonths(
      response.data?.expiryThresholdMonths ??
        response.data?.nearExpiryThresholdMonths ??
        response.data?.months,
      null
    );
    if (months != null) {
      writePathExpiryThresholdMonthsToStorage(organizationId, months);
      return months;
    }
  } catch (error) {
    if (error.response?.status && error.response.status !== 404) {
      console.warn("[pathSettings] API load failed, using local storage:", error.message);
    }
  }

  const stored = readPathExpiryThresholdMonthsFromStorage(organizationId);
  return stored ?? DEFAULT_EXPIRY_THRESHOLD_MONTHS;
};

export const savePathExpiryThresholdMonths = async (organizationId, months) => {
  const safeMonths = writePathExpiryThresholdMonthsToStorage(organizationId, months);

  try {
    await apiClient.put(`${SETTINGS_BASE}/expiry-threshold`, {
      expiryThresholdMonths: safeMonths,
    });
  } catch (error) {
    if (error.response?.status && error.response.status !== 404) {
      console.warn("[pathSettings] API save failed, stored locally only:", error.message);
    }
  }

  notifyPathExpiryThresholdChanged(safeMonths);
  return safeMonths;
};

/**
 * Notify backend to flag low-stock / reorder when using near-expiry path stock.
 * Fails silently if endpoint is not implemented yet.
 */
export const triggerPathNearExpiryLowStockAlert = async ({
  bomId,
  itemName,
  batchNumber,
  expiryDate,
  quantity,
  source = "LAB_TEST",
}) => {
  if (!bomId || !expiryDate) return null;

  const payload = {
    bomId,
    itemName: itemName || null,
    batchNumber: batchNumber || null,
    expiryDate,
    quantity: quantity ?? null,
    source,
    reason: "NEAR_EXPIRY_USE",
  };

  try {
    const response = await apiClient.post(
      `${SETTINGS_BASE}/near-expiry-low-stock`,
      payload
    );
    return response.data;
  } catch (error) {
    if (error.response?.status !== 404) {
      console.warn("[pathSettings] Near-expiry low-stock alert skipped:", error.message);
    }
    return null;
  }
};
